import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Card, CardDeck, CardHeader, CardTitle, CardBody, ButtonGroup, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getConversationMessagesRequest } from '../../ConversationActions';
import { getLoggedUser } from '../../../User/UserActions';

import MessagesList from '../messages/MessagesList';
import MessageAddForm from '../messages/MessageAddForm';

import ConversationConfig from '../form/ConversationConfig';

class Conversation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			displayConfig: false,
			minHeight: props.minHeight || 0,
			maxHeight: props.maxHeight || 0,
		};

		this.minHeightDefault = 300;
	}

	componentDidUpdate(prevProps, prevState) {
		// this.props.conversation && this.props.dispatch(getConversationMessagesRequest(this.props.conversation._id));
		if(prevProps.minHeight !== this.props.minHeight || prevProps.maxHeight !== this.props.maxHeight) {
			this.setState({
				minHeight: this.props.minHeight,
				maxHeight: this.props.maxHeight,
			});
		}
	}

	getMinHeight() {
		if(this.state.maxHeight) {
			return this.state.maxHeight;
		}
		return this.state.minHeight || this.minHeightDefault;
	}

	getMaxHeight() {
		return this.state.maxHeight || this.minHeightDefault;
	}

	render() {
		return (
			<Card>
				{!this.props.hideHeader && (
					<CardHeader className="d-flex justify-content-between">
						<CardTitle>
							<FormattedMessage id="conversation" defaultMessage="Chat" />
						</CardTitle>
						<ButtonGroup size="sm">
							{this.props.user.role !== 'student' && <Button color="primary" outline className="border-0" onClick={() => this.setState({ displayConfig: !this.state.displayConfig })}>{this.state.displayConfig ? <FontAwesomeIcon icon="chevron-left" /> : <FontAwesomeIcon icon="cog" />}</Button>}
							{this.props.reduceConversation && <Button color="secondary" outline className="border-0" onClick={this.props.reduceConversation}><FontAwesomeIcon icon="window-minimize" /></Button>}
							{this.props.closeConversation && <Button color="secondary" outline className="border-0" onClick={this.props.closeConversation}><FontAwesomeIcon icon="times" /></Button>}
						</ButtonGroup>
					</CardHeader>
				)}
				<CardBody className="p-1 pb-5" style={{ position: 'relative', minHeight: `${this.getMinHeight()}px`, maxHeight: `${this.getMaxHeight()}px` }}>
					{
						this.state.displayConfig
							? <ConversationConfig conversation={this.props.conversation} closeForm={conversation => this.setState({ displayConfig: false })} />
							: (
								<div style={{ maxHeight: `${this.props.maxHeight - 50}px`, overflow: 'scroll' }}>
									<MessagesList conversationId={this.props.conversation?._id} preserveAnonymity={this.props.preserveAnonymity || false} addMessageDateLink={this.props.addMessageDateLink || false} allowCaptureReveal={this.props.allowCaptureReveal || false} maxHeight={this.getMaxHeight()} />
									<div style={{ position: 'absolute', left: '0', bottom: '0', width: '100%' }}>
										<MessageAddForm conversation={this.props.conversation} />
									</div>
								</div>
							)
					}
				</CardBody>
			</Card>
		);
	}
}

function mapStateToProps(store, props) {
	return {
		user: getLoggedUser(store),
	};
}

Conversation.propTypes = {
	dispatch: PropTypes.func.isRequired,
	user: PropTypes.object,
	conversation: PropTypes.object.isRequired,
	reduceConversation: PropTypes.func,
	closeConversation: PropTypes.func,
	hideHeader: PropTypes.bool,
	minHeight: PropTypes.number,
	maxHeight: PropTypes.number,
	preserveAnonymity: PropTypes.bool,
	addMessageDateLink: PropTypes.bool,
	allowCaptureReveal: PropTypes.bool,
};

export default connect(mapStateToProps)(Conversation);
